export default "__VITE_ASSET__9OQu5wpR__"